import React from "react"
import { connect } from "react-redux"
import { Form as BootstrapForm } from "react-bootstrap"
import classNames from "classnames"
import { Tooltip } from "@material-ui/core";

import {
  isApplicableFieldFromConfigurations, isProductionSearchField,
} from "../../../helpers/configurationHelper";
import {
  labelField
} from "../../../helpers/dynamicFormHelper";
import MenuSearchField from "./search-fields/MenuSearchField";
import AutocompleteSearchField from "./search-fields/AutocompleteSearchField";
import NumberSearchField from "./search-fields/NumberSearchField";
import {changeFilterDispatchAction} from "../../../state/application/dispatchActions";
import TextSearchField from "./search-fields/TextSearchField";
import {
  AutocompleteSearchFieldType,
  ConfigurationsType,
  MenuSearchFieldType, NumberSearchFieldType, PossibleValuesManagement, RangeSearchFieldType,
  SearchFieldType, TextSearchFieldType
} from "../../../types/configurations";
import {ShapeType} from "../../../types/shape";
import RangeSearchField from "./search-fields/RangeSearchField";
import { FormikProps } from "formik/dist/types";
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper";
import { AppParametersType } from "../../../types/app";
import translations from "../../../translations";

interface PropsType {
  configurations: ConfigurationsType,
  fieldConfigurations: SearchFieldType,
  scopeConfigurationFields: string,
  selectedArea: ShapeType,
  formProps: FormikProps<any>,
  disabled: boolean,
  forceDisabled: boolean,
  labelClassName?: string,
  inputClassName?: string,
  changeFilterDispatchActionHandler: any, // DONT REMOVE!, it need by children elements
  appParameters: AppParametersType,
  language: string,
  bypassMandatoryLabel: boolean,
  bypassAll: boolean,
  hidden: boolean,
  isProductionField: boolean
}

const DynamicSearchField = (props: PropsType) => {
  const {
    configurations,
    fieldConfigurations,
    scopeConfigurationFields,
    selectedArea,
    labelClassName,
    inputClassName,
    formProps,
    language,
    bypassMandatoryLabel = false,
    bypassAll = false,
    hidden = false,
    isProductionField = false,
    appParameters,
    disabled,
    forceDisabled
  } = props;

  const {
    errors,
    touched,
    values,
  } = formProps;

  let dynamicField;
  if ('possibleValuesManagement' in fieldConfigurations) {
    switch (fieldConfigurations.possibleValuesManagement) {
      case PossibleValuesManagement.MENU:
        dynamicField = <MenuSearchField {...props} fieldConfigurations={fieldConfigurations as MenuSearchFieldType}/>;
        break;
      case PossibleValuesManagement.AUTOCOMPLETE:
        dynamicField = <AutocompleteSearchField {...props} fieldConfigurations={fieldConfigurations as AutocompleteSearchFieldType}/>;
        break;
      case PossibleValuesManagement.RANGE:
        dynamicField = <RangeSearchField {...props} fieldConfigurations={fieldConfigurations as RangeSearchFieldType}/>;
        break;
      default:
        console.error('Input is not being handled');
    }
  } else {
    switch (fieldConfigurations.type) {
      case 'int':
      case 'double':
      case 'float':
        dynamicField = <NumberSearchField {...props} fieldConfigurations={fieldConfigurations as NumberSearchFieldType}/>;
        break;
      default:
        dynamicField = <TextSearchField {...props} fieldConfigurations={fieldConfigurations as TextSearchFieldType}/>;
    }
  }

  if (fieldConfigurations.tooltip) {
    dynamicField = (
      <Tooltip {...DEFAULT_TOOLTIP_PROPS}
        title={translations(fieldConfigurations.tooltip, language)}
        placement="top"
      >
        <div>{dynamicField}</div>
      </Tooltip>
    )
  }

  const errorMessage = errors && errors[fieldConfigurations.name];
  const hasTouched = touched && touched[fieldConfigurations.name];

  return (
    <div
      className={classNames("row mx-0 mb-3", {
        'd-none': hidden || !isApplicableFieldFromConfigurations(configurations, appParameters, scopeConfigurationFields, fieldConfigurations.name, values, selectedArea)
      })}
    >
      <BootstrapForm.Label
        className={classNames("m-0 px-0 d-flex", labelClassName || "col-3")}
        title={fieldConfigurations.description}
      >
        <span>
          {labelField(configurations, appParameters, scopeConfigurationFields, fieldConfigurations, values, selectedArea, language, bypassMandatoryLabel)}
        </span>
      </BootstrapForm.Label>
      <BootstrapForm.Group
        className={classNames("m-0 pr-0", inputClassName || "col-9", {
          "is-invalid": hasTouched && errorMessage
        })}
      >
        {dynamicField}
        <BootstrapForm.Control.Feedback type="invalid">{errorMessage}</BootstrapForm.Control.Feedback>
      </BootstrapForm.Group>
    </div>
  );
};

const mapDispatchToState = (dispatch, ownProps) => ({
  // DONT REMOVE!, it need by children elements
  changeFilterDispatchActionHandler: (fieldName, fieldValue) => dispatch(changeFilterDispatchAction(fieldName, fieldValue, ownProps))
});

const mapStateToProps = (state) => ({
  language: state.application.appParameters.language,
  appParameters: state.application.appParameters
});


export default connect(mapStateToProps, mapDispatchToState)(DynamicSearchField);
